import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Planning } from '../../classes/planning.class';
import { User } from '../../classes/user.class';
import { PlanningDetailDialogService } from '../../services/dialog/planning-detail-dialog.service';
import { EntityTypeCode } from '../../services/entities/entity-type.class';
import { PlanningService } from '../../services/planning/planning.service';
import { UserService } from '../../services/user/user.service';

@Component({
    selector: 'app-planning-list',
    templateUrl: './planning-list.component.html',
    styleUrls: ['./planning-list.component.scss'],
    standalone: false,
})
export class PlanningListComponent implements OnInit, OnDestroy {
    planning: Planning[];
    subscriptions = new Subscription();
    users: Map<number, User>;
    tons = new Map<number, number>();

    PlanningStatus = environment.status.Planning;

    constructor(
        public dialogRef: MatDialogRef<PlanningListComponent>,
        public planningService: PlanningService,
        public planningDetailDialogService: PlanningDetailDialogService,
        public userService: UserService
    ) {}

    ngOnInit() {
        this.planningService.getListByStatus(this.PlanningStatus.BakVanWessel).subscribe(list => {
            list.forEach(pln => {
                this.tons.set(
                    pln.id,
                    pln.asphalt_list.map(asphalt => asphalt.tons).reduce((sum, current) => sum + current, 0)
                );
            });
            this.planning = list;
        });

        this.subscriptions.add(
            this.userService.getMap().subscribe(users => {
                this.users = users;
            })
        );
    }

    openPlanning(planning?) {
        if (!planning) {
            planning = this.planningService.newPlanningByType(EntityTypeCode.AsfaltTeam);
            const mainPlanning = this.planningService.getMainPlanning(planning);
            mainPlanning.begindate = null;
            mainPlanning.enddate = null;
            planning.status_key = this.PlanningStatus.PlanningBakVanWessel;
        }
        this.planningDetailDialogService.openPlanning(planning);
    }

    close() {
        this.dialogRef.close();
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
